import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { Plot, PlotStatusEnum } from '@/api/rest/resources/types/plot';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useMembershipType } from '@/hooks/useMembershipType';
import { usePathSet } from '@/hooks/usePathSet';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { buildPath } from '@/utils/buildPath';

export const useDestinationPath = () => {
  const pathSet = usePathSet();
  const membershipType = useMembershipType();
  const workstreamId = useWorkstreamId();
  const isStaffUser = useIsStaffUser();

  const getDestinationPath = (plot: Plot) => {
    const projectId = plot.project ?? plot.project_id;
    const isInvalid = plot.status === PlotStatusEnum.invalid;
    const isLandSteward = membershipType === MembershipWithOrganizationTypeEnum.land_steward;
    const canEdit = isLandSteward || isStaffUser;
    const queryParams = workstreamId ? { workstreamId } : undefined;

    if (isInvalid) {
      if (!canEdit) return null;

      if (projectId) {
        return buildPath(pathSet.editPlot, {
          pathParams: { projectId, plotId: plot.id },
          ...(queryParams ? { queryParams } : {}),
        });
      }

      return buildPath(pathSet.editPlotOrg, {
        pathParams: { plotId: plot.id },
        ...(queryParams ? { queryParams } : {}),
      });
    }

    return buildPath(pathSet.plot, {
      pathParams: { plotId: plot.id },
      queryParams,
    });
  };

  return { getDestinationPath };
};
